/**
 * MT5 market depth (Depth of Market) types - 1:1 with Vybe.SignalR.Common DTOs.
 */

export enum VybeBookBarType {
  Reset = 0,
  SellBook = 1,
  BuyBook = 2,
  SellMarket = 3,
  BuyMarket = 4,
}

/** Single MT5 DOM level (mirrors VybeBookBar). */
export interface BookBar {
  updateMask: number;
  type: VybeBookBarType;
  price: number;
  volume: number;
  lots: number;
  /** Optional internal opaque MT5 field. */
  s19?: number;
}

/** MT5 SymbolBook payload streamed via VybeOnMarketDepth. */
export interface SymbolBook {
  symbol: string;
  time: number;
  updateMask: number;
  bars: BookBar[];
  operation: number;
}

/** Server ack for SubscribeMarketDepth / UnsubscribeMarketDepth. */
export interface MarketDepthSubscribeResponse {
  success: boolean;
  errorMessage?: string | null;
  symbol: string;
  depthOfMarket: number;
}

export interface MarketDepthUnsubscribeResponse {
  success: boolean;
  errorMessage?: string | null;
  symbol: string;
}

/** Sorted, side-split snapshot used by the chart UI. */
export interface MarketDepthSnapshot {
  symbol: string;
  /** Bids sorted high → low. */
  bids: BookBar[];
  /** Asks sorted low → high. */
  asks: BookBar[];
  /** Monotonic counter that bumps on every change. Subscribers use this to skip equal frames. */
  version: number;
  /** Wall-clock ms when this snapshot was last updated locally. */
  receivedAt: number;
}

export type MarketDepthSubscriptionStatus =
  | "idle"
  | "subscribing"
  | "subscribed"
  | "unavailable"
  | "error";

export interface MarketDepthEntry {
  symbol: string;
  status: MarketDepthSubscriptionStatus;
  depthOfMarket: number;
  errorMessage?: string | null;
  snapshot?: MarketDepthSnapshot;
}
